
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Envio } from '@/__env/lib/Ventas/Envios';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;

        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Iniciar();
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            //this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
        }

        onKeyUp( e: KeyboardEvent )
        {
            if ( e.key == 'Enter' && e.altKey )
            {
                e.preventDefault();
                this.Guardar();
            }
            else if ( e.key == 'Escape' )
            {
                e.preventDefault();
                this.Controlador.Vista.BarraIzquierda.Modo = 'menu';

            }
        }

        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        public Envio: Envio = new Envio();
        public HayCambios: boolean = false;


        async Iniciar()
        {
            this.Estado = 'cargando';


            await Wait( 100 );
            if ( this.Controlador.EdicionPedido.Envio && this.Controlador.EdicionPedido.Envio.Existe )
                this.Envio = await Envio.create( this.Controlador.EdicionPedido.Envio.Id );
            else
                this.Envio = new Envio();

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            this.Estado = 'cargando';
            let e = await this.Envio.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.Controlador.EdicionPedido.Envio = this.Envio;
                this.Cerrar();
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );

            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        Cerrar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }



    }
